import React, { Component } from 'react'
import PersonalDetails from '../components/riderregister/PersonalDetails'
import WorkDetails from '../components/riderregister/WorkDetails'
import Confirm from '../components/riderregister/Confirm'
import swal from 'sweetalert'

export class RiderRegistration extends Component {
  state = {
    step: 1,
    email: '',
    username: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    phone: '',
    email_address: '',
    start_time: '',
    completion_time: '',
    street_address: '',
    parish: '',
    dob: '',
    gender: '',
    reference_name: '',
    reference_phone: '',
    emergency_contact_name: '',
    emergency_contact_phone: '',
    work_days: '',
    work_hours: '',
    weekly_availability: '',
    vehicle_type: '',
    vehicle_type_secondary: '',
    driving_period: '',
    license_number: '',
    license_expiry: '',
    password: '',
    courier_history: '',
    courier: false,
    has_insurance: false,
    is_ends: false,
    is_convicted: false,
    has_involved_in_trafic_infraction: false,
    involved_in_crime: false,
    has_smart_phone: false,
    smart_phone_type: '',
    use_online_banking: false,
    has_bill_express_account: false,
    user_agree: 'true',
    workdetaildata: {},
  }

  // Proceed to next step
  nextStep = () => {
    const { step } = this.state
    this.setState({
      step: step === 4 ? step : step + 1,
    })
  }

  confirmDataState = (data) => {
    this.state.workdetaildata = data
    this.nextStep()
  }

  // Go back to prev step
  prevStep = () => {
    const { step } = this.state
    this.setState({
      step: step - 1,
    })
  }

  componentDidMount = () => {
    window.scrollTo(0, 0)
    const rider_api_token = localStorage.getItem('rider_api_token')

    if (rider_api_token !== null) {
      this.nextStep()
    }
  }

  // Handle fields change
  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value })
  }

  render() {
    const { step } = this.state

    const {
      email,
      username,
      first_name,
      middle_name,
      last_name,
      phone,
      email_address,
      start_time,
      completion_time,
      street_address,
      parish,
      dob,
      gender,
      reference_name,
      reference_phone,
      emergency_contact_name,
      emergency_contact_phone,
      work_days,
      work_hours,
      weekly_availability,
      vehicle_type,
      vehicle_type_secondary,
      driving_period,
      license_number,
      license_expiry,
      password,
      courier_history,
      courier,
      has_insurance,
      is_ends,
      is_convicted,
      has_involved_in_trafic_infraction,
      involved_in_crime,
      has_smart_phone,
      smart_phone_type,
      use_online_banking,
      has_bill_express_account,
      user_agree,
    } = this.state
    const values = {
      email,
      username,
      first_name,
      middle_name,
      last_name,
      phone,
      email_address,
      parish,
      dob,
      gender,
      password,
      start_time,
      completion_time,
      street_address,
      reference_name,
      reference_phone,
      emergency_contact_name,
      emergency_contact_phone,
      work_days,
      work_hours,
      weekly_availability,
      vehicle_type,
      vehicle_type_secondary,
      driving_period,
      license_number,
      license_expiry,
      courier_history,
      courier,
      has_insurance,
      is_ends,
      is_convicted,
      has_involved_in_trafic_infraction,
      involved_in_crime,
      has_smart_phone,
      smart_phone_type,
      use_online_banking,
      has_bill_express_account,
      user_agree,
    }

    switch (step) {
      case 1:
        return (
          <PersonalDetails
            logOut={this.props.logOut}
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            values={values}
          />
        )
      case 2:
        return (
          <WorkDetails
            logOut={this.props.logOut}
            confirmDataState={this.confirmDataState}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            handleChange={this.handleChange}
            values={values}
          />
        )
      case 3:
        return (
          <Confirm
            workdetaildata={this.state.workdetaildata}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            values={values}
          />
        )
      case 4:
        return swal({
          title: 'Welcome!',
          text: 'Registration successful!',
          icon: 'success',
          timer: null,
          closeOnClickOutside: false,
        }).then(() => {
          window.location.href = '/'
        })

      default:
    }
  }
}

export default RiderRegistration
